import {CompanySignup} from '../core/company-signup';
import {DOM} from '../core/dom';

export namespace CompaniesCallToAction {
  export function onload(): void {
    DOM.onIdClick('company-call-to-action-btn', CompanySignup.display);
  }
}